import type { Faro } from '@grafana/faro-web-sdk'

let faro: Faro | undefined

/**
 * Starts Grafana Faro when `VITE_FARO_URL` is set: JavaScript errors, logs and
 * load times, without session tracking or user id, so nothing is stored in the
 * browser and no consent is needed.
 */
export async function initTelemetry(): Promise<void> {
  const url = import.meta.env.VITE_FARO_URL
  if (!url) return
  const sdk = await import('@grafana/faro-web-sdk')
  faro = sdk.initializeFaro({
    url,
    app: { name: 't.armx', version: __BUILD__.sha, environment: import.meta.env.MODE },
    sessionTracking: { enabled: false },
    instrumentations: sdk.getWebInstrumentations({ captureConsole: false }),
  })
}

/**
 * Sends an application event to Loki, through Faro.
 * @param event - What happened, as a short stable name: `code_requested`, `message_sent`.
 * @param context - Extra fields; never personal data.
 * @example
 * log('realtime_error', { status: 'CHANNEL_ERROR' })
 */
export function log(event: string, context?: Record<string, string>): void {
  faro?.api.pushLog([event], { context })
}
